import * as React from 'react';
import {
    Paper, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, FormControl, SmartSelect
} from "@leap4/frontend"
import {Fragment, useEffect, useState} from "react";
import { Role} from "@leap4/auth"
import ISelectable from "../../../interfaces/selectable.interface";
import {getAllServices} from "../../../actions/services";
import {useDispatch} from "react-redux";
import * as _ from "lodash";
import {getRoleFromISelectbleArr, getRoleIndexFromISelectableArr} from "../../../utils/user.utils";
import style from "./style"

interface Props {
    open: boolean,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>,
    setServiceOnUser: Function,
    isAdd: boolean
    serviceName?: string | null
    userServices: { [k: string]: any } | undefined
    external?: boolean
}

const AddEditServiceDialog = ({open, setOpen, setServiceOnUser, isAdd, serviceName, userServices, external}: Props) => {
    const classes = style();
    const dispatch = useDispatch();
    const [services, setServices] = useState<Array<ISelectable>>([]);
    const [selectedServiceInd, setSelectedServiceInd] = useState<number>(0);

    const arrRoles: { name: string, value: string }[] = [];
    _.forIn(Role, (value: Role, key: string) => arrRoles.push({name: key, value}))
    const [roles, setRoles] = useState(arrRoles);
    const [selectedRoleInd, setSelectedRoleInd] = useState<number>(0);

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmit = () => {
        const serviceMetadata = {
            roles: getRoleFromISelectbleArr(roles, selectedRoleInd)
        }

        const name = (!isAdd && !_.isNil(serviceName)) ? serviceName : services[selectedServiceInd].name;
        // If we in edit mode we receive the service name props.
        setServiceOnUser(name, serviceMetadata)
        handleClose();
    }

    useEffect(() => {
        (async () => {

            if (!isAdd && userServices && serviceName) {
                const index = getRoleIndexFromISelectableArr(roles, userServices[serviceName].roles[0]);
                setSelectedRoleInd(index)

            } else if (isAdd) {
                const data = await getAllServices(dispatch);

                // Convert the instances to ISelectable form.
                if (data) {
                    const selectableServices: ISelectable[] = [];
                    data.forEach(service => {
                        if (!userServices || !Object.keys(userServices).includes(service.name) && external !== undefined && service.external !== undefined) {
                            if ( !external || external === service.external) {
                                selectableServices.push({name: service.name, value: service._id});
                            }

                        }
                    });


                    setServices(selectableServices)
                }
            }
        })()
    }, [userServices, isAdd, external])

    return (
        <div>
            <Dialog fullWidth={true}
                    maxWidth="md" open={open} onClose={handleClose}>
                <DialogTitle>
                    {isAdd ? "Add Service Metadata" : `Edit Service ${serviceName} Role`}
                </DialogTitle>
                <DialogContent>

                        <form style={classes.form} noValidate onSubmit={handleSubmit}>
                            <Grid container width={"100%"}  item style={{ padding: 10, alignItems: "center", justifyContent: "center"}} gap={3} >
                                        {isAdd &&
                                <Grid item justifyContent="center" md={7} sm={10}>
                                    <FormControl variant="outlined" sx={classes.formControl}>
                                        <Fragment>
                                            <SmartSelect items={services}
                                                         selectedItemInd={selectedServiceInd}
                                                         setSelectedState={setSelectedServiceInd}
                                                         title="Select Service"/>
                                        </Fragment>
                                    </FormControl>
                                </Grid>
                                        }
                                <Grid item justifyContent="center" md={7} sm={10}>
                                    <FormControl variant="outlined" sx={classes.formControl}>
                                        <SmartSelect items={roles} selectedItemInd={selectedRoleInd}
                                                     setSelectedState={setSelectedRoleInd} title="Service Roles"/>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </form>


                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleSubmit}>Submit</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}


export default AddEditServiceDialog;